module.exports = __webpack_public_path__ + "img/brocc.4adebbf.png";